const initialState = {
  pageNo: 0,
  pageSize: 10,
  search: "",
  userType: { name: "all", value: "all", label: "All" },
  role: { name: "all", value: "all", label: "All" },
  fromdate: "",
  tilldate: "",
  activefromdate: "",
  activetilldate: "",
  sortfilter: "createdDate",
  sortorder: "desc",
  levelid: "",
  levelvalue: "",
  isLoading: true,
  userTypeList: [],
  users: [],
  totalCount: 0,
  reload: "1",
  isDrawerOpen: 0,
  roleList: [],
  selectedUser: [],
  domainFilter: [],
  statusList: [],
  statusValue: { name: "all", value: "all", label: "All" },
};

const manageUserReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case "getdataMU":
      state = {
        ...state,
        users: payload.users,
        totalCount: payload.totalCount,
        userTypeList: payload.userTypes,
        isLoading: false,
      };
      return state;
    case "updatePageNoMU":
      state = { ...state, pageNo: payload, isLoading: true };
      return state;
    case "updatePageSizeMU":
      state = { ...state, pageNo: 0, isLoading: true, pageSize: payload };
      return state;
    case "tabSearchMU":
      state = { ...state, pageNo: 0, isLoading: true, search: payload };
      return state;
    case "sortOrderMU":
      state = { ...state, pageNo: 0, isLoading: true, sortorder: payload };
      return state;
    case "sortFilterMU":
      state = {
        ...state,
        pageNo: 0,
        isLoading: true,
        sortfilter: payload,
      };
      return state;
    case "reloadMU":
      state = {
        ...state,
        isLoading: true,
        reload: Math.random() * 10,
      };
      return state;
    case "drawerOpenMU":
      state = { ...state, isDrawerOpen: payload };
      return state;
    case "selectedUserMU":
      state = { ...state, selectedUser: payload };
      return state;
    case "updateDataMU":
      state = { ...state, users: payload };
      return state;
    case "updateroleListMU":
      state = { ...state, roleList: payload };
      return state;
    case "updateStatus":
      state = { ...state, statusList: payload };
      return state;
    case "updatefiltersDataMU":
      state = {
        ...state,
        role: payload.role,
        statusValue: payload.status,
        userType: payload.userType,
        fromdate: payload.fromDate,
        tilldate: payload.tillDate,
        activefromdate: payload.activeFromDate,
        activetilldate: payload.activeTillDate,
        domainFilter: payload.domain,
        isDrawerOpen: 0,
        pageNo: 0,
      };
      return state;
    case "isLoadingAMU":
      state = { ...state, isLoading: payload };
      return state;
    case "updatePageAMU":
      state = { ...state, pageNo: 0 };
      return state;
    case "initialPageNoAMU":
      state = { ...state, pageNo: 0, search: "" };
      return state;
    default:
      return state;
  }
};
export default manageUserReducers;
